import * as z from 'zod';
import { VALIDATION_MESSAGES } from '@/features/forms/validation';

const validationScheme = z
  .object({
    travelReason: z.string().min(1, { message: VALIDATION_MESSAGES.required }),
    travelPlannedDate: z.string().min(1, { message: VALIDATION_MESSAGES.required }),
    travelDestinations: z
      .array(
        z.object({
          label: z.string(),
          value: z.string(),
        })
      )
      .min(1, { message: VALIDATION_MESSAGES.required }),
    travelCitiesToVisit: z.array(
      z.object({
        label: z.string(),
        value: z.string(),
      })
    ),
    // .min(1, { message: VALIDATION_MESSAGES.required }),
    travelExperiencies: z
      .array(
        z.object({
          label: z.string(),
          value: z.string(),
        })
      )
      .min(1, { message: VALIDATION_MESSAGES.required }),
    travelBudget: z.string().min(1, { message: VALIDATION_MESSAGES.required }),
    travelSpeakEng: z.string(),
    travelLangPref: z.string(),

    // Passengers
    travelPaxAdtNumber: z.string(),
    travelPaxChdNumber: z.string(),
    travelPaxInfNumber: z.string(),

    // Accommodation
    travelAccommodationCategory: z.string(),
    travelAccommodationType: z.string(),

    // Additional information
    message: z.string(),
    purchasedFlight: z.string().min(1, { message: VALIDATION_MESSAGES.required }),

    // Contact
    name: z.string().min(1, { message: VALIDATION_MESSAGES.required }),
    email: z.string().email({ message: VALIDATION_MESSAGES.email }),
    phone: z.string().min(1, { message: VALIDATION_MESSAGES.required }),
    subscribeNews: z.boolean(),

    phoneData: z.object({
      number: z.string(),
      countryName: z.any(),
      iso2: z.any(),
      dialCode: z.any(),
    }),
  })
  .required();

export type FormCreateJourneyDataType = z.infer<typeof validationScheme>;

export default validationScheme;
